import { render, staticRenderFns } from "./LimitedInput.vue?vue&type=template&id=0c8207bb&"
import script from "./LimitedInput.vue?vue&type=script&lang=js&"
export * from "./LimitedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports